<template>
  <div
    class="p-card"
    style="    width: 50px;
    height: 50px;
    display: flex;
    background: #00CCCC;
    border-radius: 50%;
    align-items: center;
    justify-content: center;"
  >
    <div
      class="p-card"
      style="width: 38px;
    height: 38px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #BEB9B0;
    font-size: 16px;"
    >
      {{ timer }}s
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: ["timer"]
})
export default class CountDown extends Vue {
  timer!: number;
}
</script>

<!-- 
import { take, map, combineAll } from "rxjs/operators";
import { interval } from "rxjs";
const time = 10;
const source$ = interval(1000).pipe(take(1));
const example$ = source$.pipe(
  map(val =>
    interval(1000).pipe(
      map(i => {
        let x = time;
        return x - i;
      }),
      take(time)
    )
  )
);

example$
  .pipe(combineAll())
  .subscribe((resutl: any) => {
    if (resutl[0] === 1) {
      console.log(resutl);
      setTimeout(() => {
        console.log("het gio");
      }, 1000);
    } else {
      console.log(resutl[0]);
    }
  }); -->
